import { useDarkMode } from "../../../context/ThemeContext";
import { getThemeClasses } from "../../../utils/ThemeClasses";

export type ReportDocumentType = "pdf" | "excel";

interface ReportFormatToggleProps {
  value: ReportDocumentType;
  onChange: (value: ReportDocumentType) => void;
}

const OPTIONS: { value: ReportDocumentType; icon: string; label: string }[] = [
  { value: "pdf", icon: "ri-file-pdf-2-line", label: "PDF" },
  { value: "excel", icon: "ri-file-excel-2-line", label: "Excel" },
];

export default function ReportFormatToggle({ value, onChange }: ReportFormatToggleProps) {
  const { isDarkMode } = useDarkMode();
  const themeClasses = getThemeClasses(isDarkMode);
  const inactiveHover = isDarkMode ? "hover:bg-dark-hover" : "hover:bg-gray-100";

  return (
    <div className={`flex w-full lg:inline-flex lg:w-auto rounded-lg border overflow-hidden ${themeClasses.cardBorder}`}>
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            title={opt.label}
            aria-label={opt.label}
            aria-pressed={active}
            className={`flex flex-1 lg:flex-none items-center justify-center gap-2 lg:gap-0 lg:w-10 h-10 text-base transition-colors ${
              active
                ? `${themeClasses.buttonBg} text-white`
                : `${themeClasses.inputBg} ${themeClasses.text} ${inactiveHover}`
            }`}
          >
            <i className={opt.icon} />
            <span className="text-sm lg:hidden">{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
}
